import { PureLightTheme } from "./schemes/PureLightThem";

export function themeCreator(theme) {
  return themeMap[theme];
}

const Theme = {
  colors: {
    gradients: {
      blue1: "",
      blue2: "",
      blue3: "",
      blue4: "",
      blue5: "",
      orange1: "",
      orange2: "",
      orange3: "",
      purple1: "",
      purple3: "",
      pink1: "",
      pink2: "",
      green1: "",
      green2: "",
      black1: "",
      black2: "",
    },
    shadows: {
      success: "",
      error: "",
      primary: "",
      warning: "",
      info: "",
    },
    alpha: {
      white: {
        5: "",
        10: "",
        30: "",
        50: "",
        70: "",
        100: "",
      },
      trueWhite: {
        5: "",
        10: "",
        30: "",
        50: "",
        70: "",
        100: "",
      },
      black: {
        5: "",
        10: "",
        30: "",
        50: "",
        70: "",
        100: "",
      },
    },
    secondary: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    primary: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    success: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    warning: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    error: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    info: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
  },
  general: {
    reactFrameworkColor: "",
    borderRadiusSm: "",
    borderRadius: "",
    borderRadiusLg: "",
    borderRadiusXl: "",
  },
  sidebar: {
    background: "",
    boxShadow: "",
    width: "",
    textColor: "",
    dividerBg: "",
    menuItemColor: "",
    menuItemColorActive: "",
    menuItemBg: "",
    menuItemBgActive: "",
    menuItemIconColor: "",
    menuItemIconColorActive: "",
    menuItemHeadingColor: "",
  },
  header: {
    height: "",
    background: "",
    boxShadow: "",
    textColor: "",
  },
};

const ThemeOptions = {
  colors: {
    gradients: {
      blue1: "",
      blue2: "",
      blue3: "",
      blue4: "",
      blue5: "",
      orange1: "",
      orange2: "",
      orange3: "",
      purple1: "",
      purple3: "",
      pink1: "",
      pink2: "",
      green1: "",
      green2: "",
      black1: "",
      black2: "",
    },
    shadows: {
      success: "",
      error: "",
      primary: "",
      warning: "",
      info: "",
    },
    alpha: {
      white: {
        5: "",
        10: "",
        30: "",
        50: "",
        70: "",
        100: "",
      },
      trueWhite: {
        5: "",
        10: "",
        30: "",
        50: "",
        70: "",
        100: "",
      },
      black: {
        5: "",
        10: "",
        30: "",
        50: "",
        70: "",
        100: "",
      },
    },
    secondary: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    primary: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    success: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    warning: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    error: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
    info: {
      lighter: "",
      light: "",
      main: "",
      dark: "",
    },
  },
  general: {
    reactFrameworkColor: "",
    borderRadiusSm: "",
    borderRadius: "",
    borderRadiusLg: "",
    borderRadiusXl: "",
  },
  sidebar: {
    background: "",
    boxShadow: "",
    width: "",
    textColor: "",
    dividerBg: "",
    menuItemColor: "",
    menuItemColorActive: "",
    menuItemBg: "",
    menuItemBgActive: "",
    menuItemIconColor: "",
    menuItemIconColorActive: "",
    menuItemHeadingColor: "",
  },
  header: {
    height: "",
    background: "",
    boxShadow: "",
    textColor: "",
  },
};

export { Theme, ThemeOptions };

const themeMap = {
  PureLightTheme: PureLightTheme,
};
